import React, { useState } from "react";
import { getCookie, logAction } from "./log.js";
import "../css/PopUpRenameFile.css";

/**
 * Popup permettant de renommer un fichier ou dossier.
 *
 * @param {Object} props
 * @param {Object} props.object - Objet représentant le fichier/dossier à renommer (avec id, name, path, type).
 * @param {function} props.onClose - Fonction appelée pour fermer la popup. Peut recevoir un booléen indiquant si l'opération a été annulée.
 * @param {function} [props.onRename] - Fonction optionnelle appelée après un renommage réussi.
 */
const PopUpRenameObject = ({ object, onClose, onRename }) => {
    // Extraction du nom de base et extension du fichier
    const lastDot = object.name.lastIndexOf(".");
    const baseName = lastDot > 0 ? object.name.substring(0, lastDot) : object.name;
    const extension = lastDot > 0 ? object.name.substring(lastDot) : "";

    const [newBaseName, setNewBaseName] = useState(baseName);
    const [error, setError] = useState("");
    const API_URL = process.env.REACT_APP_API_URL;

    /**
     * Soumet le nouveau nom à l'API pour modification.
     * Valide que le nom n'est pas vide et différent du nom actuel.
     * Enregistre l'action dans les logs si succès.
     */
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newBaseName.trim()) {
            setError("Le nom ne peut pas être vide.");
            return;
        }

        const newName = newBaseName + extension;
        if (newName === object.name) {
            onClose(false); // Fermeture sans modification
            return;
        }

        try {
            const res = await fetch(`${API_URL}/api/modifyObject.php`, {
                method: "POST",
                credentials: 'include',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    dossier: object.id,
                    old: object.path,
                    new: newName,
                    action: "rename",
                    type: object.type
                })
            });

            const data = await res.json();
            if (res.ok) {
                logAction({
                    action: "renameFile",
                    dossierId: object.id,
                    utilisateurId: getCookie("userId"),
                    fichier: newName,
                    path: object.path,
                });
                onClose();
                if (onRename) onRename(newName);
            } else {
                console.error("Erreur API :", data);
                alert("Erreur lors du renommage du fichier.");
            }
        } catch (err) {
            console.error("Erreur réseau :", err);
            alert("Erreur réseau lors du renommage.");
        }
    };

    return (
        <div className="popupRename-overlay">
            <div className="popupRename-content">
                <h3>Renommer le fichier</h3>
                <form onSubmit={handleSubmit}>
                    <div className="popupRename-input" style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <input
                            type="text"
                            value={newBaseName}
                            onChange={(e) => setNewBaseName(e.target.value)}
                            autoFocus
                        />
                        <span style={{ color: "#888", fontSize: "1em" }}>{extension}</span>
                    </div>
                    {error && <p className="error-message">{error}</p>}
                        <div className="flex justify-end my-2 -popupAdFile-buttons">
                            <button className="btn btn-success mr-2" type="submit">Ajouter</button>
                            <button className="btn" type="button" onClick={onClose}>Annuler</button>
                        </div>      
                </form>
            </div>
        </div>
    );
};

export default PopUpRenameObject;
